export const CUSTOMER_RISK_LEVEL = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
};
